import React from 'react';
import './Congrat.css';
import {Modal} from 'react-bootstrap'

const ConnectFinlogixPop = ({text, show, closePop, connectFinlogix, lang}) => {


    return (

        <Modal show={show} onHide={() => closePop('connect')} size="lg" centered className={`finlogix-modal my-modal ${lang}`}>
            <Modal.Header closeButton={true}>
            </Modal.Header>
            <Modal.Body>
                <h3>{text.title}</h3>
                <p>{text.p1}</p>
                <p>{text.p2}</p>
                <p>{text.p3}</p>
                <div>
                    <button className="modal-btn" onClick={connectFinlogix}>{text.button}</button>
                </div>            
            </Modal.Body>
        </Modal>

    );
};
export default ConnectFinlogixPop
